import InfoOutlined from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { snakeCase, truncate } from 'lodash-es';

import { ConsentContentDto } from 'api/v1/data-contracts';
import { CustomInfoDialog } from 'library/components/controls/dialogs/CustomInfoDialog';
import { useDialogState } from 'library/hooks/useDialogState';

type GdprDialogProps = {
	content: ConsentContentDto;
};
export const GdprDialog = ({
	content: { contentLines, header, title },
}: GdprDialogProps) => {
	const { open, handleOpen, handleClose } = useDialogState(false);

	return (
		<>
			<IconButton onClick={handleOpen}>
				<InfoOutlined color="secondary" />
			</IconButton>
			<CustomInfoDialog
				dialogTitle={title}
				headerText={
					<Typography sx={{ textDecoration: 'underline' }}>
						{header}
					</Typography>
				}
				open={open}
				onClose={handleClose}>
				{contentLines.map((line, index) => (
					<Typography
						key={snakeCase(truncate(line, { length: 10 }))}
						gutterBottom={index < contentLines.length - 1}>
						{line}
					</Typography>
				))}
			</CustomInfoDialog>
		</>
	);
};
